import React, { useContext, useState } from "react";
import { ToastContainer } from "react-toastify";
import { MdUpload } from "react-icons/md";
import PlaybookContext from "../../context/playbookContext";
import PageHeading from "../PageHeading";
import PlaybookUploadForm from "./PlaybookUploadForm";
import PlaybookList from "./PlaybookList";

const PlaybookResult = () => {
  const playbookContext = useContext(PlaybookContext);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleOpenModal = () => {
    playbookContext.updateAddMode(true);
    playbookContext.updateEditData({});
    playbookContext.updateOpenModal(true);
  };

  const handleCloseModal = () => {
    playbookContext.updateOpenModal(false);
  };

  const handleSaved = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <div className="gms-page-section report-tabs">
      <ToastContainer />

      <div className="gms-wrapper">
        <PageHeading
          pageTitle="Playbook"
          icon={<MdUpload />}
          pageModalTitle="Upload JSON"
          pageModalOpen={handleOpenModal}
        />

        <PlaybookUploadForm
          isOpen={playbookContext.isOpenModal}
          onClose={handleCloseModal}
          onSaved={handleSaved}
        />

        <PlaybookList refreshKey={refreshKey} />
      </div>
    </div>
  );
};

export default PlaybookResult;
